import { synchronizeAvatars as synchronize } from "../duck/epics";
import avatarFiles from "src/modules/avatar/avatar-files";

const clearData = avatarFiles.deleteAll;

export default {
  clearData,
  synchronize
};
